import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

/**
 * 页面追踪 Hook
 * 在页面组件中使用此 Hook 来追踪页面浏览
 * 
 * @param {string} pageTitle - 页面标题（可选）
 * @param {object} additionalData - 额外的追踪数据（可选）
 * 
 * @example
 * function MyPage() {
 *   usePageTracking('我的页面');
 *   return <div>...</div>;
 * }
 */
function usePageTracking(pageTitle, additionalData = {}) {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const title = pageTitle || document.title;
    
    // 追踪页面浏览
    trackPageView(path, title);
    
    // 如果提供了额外数据，可以在这里记录
    if (Object.keys(additionalData).length > 0) {
      console.log('📊 页面追踪数据:', { path, title, ...additionalData });
    }
  }, [location, pageTitle, additionalData]);
}

export default usePageTracking;

